




















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrganisationService } from '@store/service/OrganisationService';
import ErrorResponseMixin from '@mixin/errorResponse';
import ProjectItem from '@part/dashboard/ProjectItem';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            communityOrganisation: null,
        }
    },

    components: {
        ProjectItem,
    },

    mixins: [
        ErrorResponseMixin,
    ],

    created() {
        const community = this.projects.community;
        if (community.length) {
            this.organisationService = new OrganisationService(this.$store);
            this.organisationService.getOrganisation(community[0].organisation_id).then(response => {
                if (response instanceof Error)
                    this.errorData = this.getErrorMessage(response);
                this.communityOrganisation = response.data;
            });
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class UserHeader extends Vue {
    @Prop() projects!: object|null
    @Prop({ default: 'open' }) type!: string
};

